<template>
  <div id="diy_infomation">
    <div class="top">
      <div
        class="btn"
        v-for="(item, index) in dialogData.blist"
        :key="index"
        @click="ButtonClick(item.active, item)"
      >
        <span>
          <i :class="item.icon"></i>
          {{ item.name }}</span
        >
      </div>
    </div>
    <div class="content">
      <!-- 基本输入框的弹出框 -->
      <div class="dialog-content customScrollBar">
        <div class="line" v-for="(item, index) in dialogData.data" :key="index">
          <div class="title">
            <span v-if="item.isNull">*</span>{{ item.name }}
          </div>
          <div class="value yy" v-if="item.type == 'text'">
            {{ item.value }}
          </div>
          <!-- 文件上传pdf或者png,jpg,jpeg -->
          <div class="value" v-if="item.type == 'file_icons'"></div>

          <div class="value yy" v-if="item.type == 'file'">
            <span
              class="aa"
              v-for="(file, ii) in item.value"
              :key="ii"
              @click="open(file.url)"
            >
              <span v-if="ii > 0">,</span> {{ file.name }}
            </span>
            <span v-if="item.value == null || item.value.length == 0">无</span>
          </div>
          <div class="value" v-if="item.type == 'icons'">
            <div class="idcardImg" v-viewer="{ movable: false }">
              <div class="idcardImgBox">
                <div class="upbox">
                  <img :src="item.value[0].path" alt="" />
                </div>
              </div>
              <div class="idcardImgBox">
                <div class="upbox">
                  <img :src="item.value[1].path" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
              clearable
              :disabled="item.disabled"
            ></el-input>
          </div>
          <div class="value" v-if="item.type == 'select'">
            <el-select
              v-model="item.value"
              :placeholder="'请选择' + item.name"
              clearable
              filterable
              @change="changeSH"
            >
              <el-option
                v-for="(it, i) in item.options"
                :key="i"
                :label="it.label"
                :value="it.value"
                :disabled="it.disabled"
              >
              </el-option>
            </el-select>
          </div>
          <div class="value" v-if="item.type == 'select_input'">
            <el-select
              v-model="item.value"
              :placeholder="'请输入或选择' + item.name"
              clearable
              filterable
              @blur="selectBlur"
              @clear="selectClear"
              @change="selectChange"
            >
              <el-option
                v-for="(it, i) in item.options"
                :key="i"
                :label="it.label"
                :value="it.value"
                :disabled="it.disabled"
              >
              </el-option>
            </el-select>
          </div>

          <!-- 可搜索的下拉选 -->
          <div class="value" v-if="item.type == 'state'">
            <el-autocomplete
              v-model="item.value"
              :fetch-suggestions="querySearchAsyncAsync"
              :placeholder="'请输入' + item.name"
              @select="handleSelect"
              @blur="blur"
            ></el-autocomplete>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infomationData: {
      type: Object,
      default: function () {
        return {
          flag: true,
          blist: [], //按钮
          data: [],
          buttonArray: [
            { name: "确定", active: "makesure", type: "primary" },
            { name: "取消", active: "cancel", type: "danger" },
          ],
        };
      },
    },
  },
  data() {
    return {
      dialogData: this.infomationData,
      restaurants: [],
      state: "",
      timeout: null,
    };
  },
  methods: {
    // handleClick(active, item) {
    //   this.$emit("handleClick", active, item);
    // },
    changeData(value) {
      this.$emit("changeData", value);
    },
    ButtonClick(active, item) {
      this.$emit("ButtonClick", active, item);
    },
    btnClick(active, item) {
      this.$emit("btnClick", active, item);
    },

    selectBlur(e) {
      for (let index = 0; index < this.dialogData.data.length; index++) {
        const element = this.dialogData.data[index];
        //输入选择框
        if (element.type == "select_input") {
          element.value = e.target.value;
          this.$forceUpdate(); // 强制更新
        }
      }
      // this.$forceUpdate(); // 强制更新
    },
    selectClear() {
      this.$forceUpdate();
    },
    selectChange(val) {
      this.$forceUpdate();
    },
    changeSH(e) {
      this.$emit("changeSH", e);
    },
    open(url) {
      window.open(url, "_blank");
    },
    querySearchAsyncAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.value.indexOf(queryString) === 0;
      };
    },
    handleSelect(item) {
      console.log(item, this.state);
    },
    blur() {
      console.log(this.state);
    },
    /*  */
    getLabelList() {
      this.$request(
        "post",
        "/label/getLabelList",
        { type: "refuseReason" },
        (data) => {
          console.log("//查看审核不通过原因", data);
          let arr = [];
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let obj = {
              id: element.id,
              value: element.content,
            };
            arr.push(obj);
          }
          this.restaurants = arr;
        }
      );
    },
  },
  mounted() {
    this.getLabelList();
  },
};
</script>

<style lang="less" scoped>
#diy_infomation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* 头部按钮 */
  .top {
    width: 100%;
    height: 42px;
    box-sizing: border-box;
    margin-bottom: 20px;
    display: flex;

    .btn {
      box-sizing: border-box;
      padding: 10px 20px;
      border-radius: 3px;
      background: #0076fc;
      margin-right: 30px;
      transition: 0.3s;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      > span {
        font-size: 14px;
        font-weight: 400;
        height: 100%;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          margin-right: 3px;
        }
      }
      &:hover {
        cursor: pointer;
        background-color: #025bc0;
      }
    }
  }
  /* 查看个人具体信息 */
  .content {
    width: 100%;
    height: 0;
    flex: 1;
    // height: 700px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    box-sizing: border-box;

    .dialog-content {
      width: 100%;
      height: 100%;
      // overflow: auto;
      display: flex;
      flex-wrap: wrap;
      // flex-direction: column;
      // align-content: space-around;
      box-sizing: border-box;

      .line {
        width: 40%;
        height: auto;
        min-height: 45px;
        display: flex;
        align-items: center;
        margin-top: 3px;
        margin-bottom: 2px;

        > .title {
          width: 30%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          font-weight: bold;
          padding-right: 10px;
          box-sizing: border-box;
          /* 星号 */
          > span {
            width: 8px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fa0a0a;
          }
        }

        > .value {
          width: 0;
          flex: 1;
          min-height: 45px;
          height: auto;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          padding: 0 2px;
          box-sizing: border-box;
          text-align: left;

          .uploadList {
            width: 100%;
            height: 45px;
            border-radius: 12px;
            background: rgba(247, 247, 247, 1);
            display: flex;
            padding: 2px 5px;
            box-sizing: border-box;

            align-items: center;
            .upBox {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 2px 5px;
              margin-bottom: 5px;
              box-sizing: border-box;
            }
            > span {
              font-size: 12px;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
            }
            > img {
              width: 12px;
              height: 12px;
            }
            .file {
              font-size: 14px;
              letter-spacing: 1px;
              text-align: left;
            }
          }

          .idcardImg {
            width: 100%;
            height: 90px;
            display: flex;
            justify-content: space-between;
            .idcardImgBox {
              width: 45%;
              height: 90px;
              background: rgba(247, 247, 247, 1);
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              .upbox {
                // width: 100%;
                height: 90px;
                opacity: 1;
                border-radius: 7px;
                background: rgba(247, 247, 247, 1);
                display: flex;
                justify-content: center;
                align-items: center;
                > img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .idcardImgBox_upload {
              width: 100%;
              height: 100%;
              position: absolute;
              height: 135px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-radius: 7px;
              position: relative;
              > img {
                width: 160px;
                height: 111px;
              }
              > span {
                font-size: 10px;
                font-weight: 400;
                color: rgba(128, 128, 128, 1);
              }
            }
          }

          .upbox {
            width: 180px;
            height: 90px;
            opacity: 1;
            border-radius: 7px;
            background: rgba(247, 247, 247, 1);
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        > .yy {
          background-color: #f7f7f7;
          padding: 0 10px;
          box-sizing: border-box;
          font-size: 15px;
          border-radius: 9px;
          display: flex;
          flex-wrap: wrap;
          > .aa {
            color: #0076fc;
            cursor: pointer;
            transition: 0.3s;
            margin-right: 3px;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  .el-autocomplete {
    width: 100% !important;
  }
}
</style>
